import script from "./BaseStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseStep.vue?vue&type=script&setup=true&lang=ts"

import "./BaseStep.vue?vue&type=style&index=0&id=5802bf48&scoped=true&lang=scss"
import "./BaseStep.vue?vue&type=style&index=1&id=5802bf48&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5802bf48"]])

export default __exports__